import { render, staticRenderFns } from "./morePage.vue?vue&type=template&id=b3137c5c&scoped=true"
import script from "./morePage.vue?vue&type=script&lang=js"
export * from "./morePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3137c5c",
  null
  
)

export default component.exports